
export default function CenterColumn({children}) {
    return (
        <div style={{minWidth: "65%", maxWidth: 1300, margin: "auto", padding: "0 20px"}}>
            {children}
        </div>
    );
}